import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  closeProductModal,
  refreshProductList,
} from "../../../redux/features/productModalSlice";

import { AddColor } from "../../../redux/services/ColorServices/color.Services";
import { ActiveCategoryList } from "../../../redux/services/categoriesService/categories.Services";
import { ActiveSubCategoryList } from "../../../redux/services/subCategoriesService/subCategories.Services";
import Swal from "sweetalert2";
import { successToast } from "../../../Utils/toast";

function CreateColor({ refreshData }) {
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    category_id: "",
    sub_category_id: "",
    color_name: "",
    color_hex: "",
    description: "",
    status: 1,
  });
  const loadCategories = async () => {
    try {
      const res = await ActiveCategoryList();

      setCategories(res?.data || []);
    } catch (error) {
      console.log(error);
    }
  };
  const loadSubCategories = async (categoryId) => {
    try {
      const res = await ActiveSubCategoryList(categoryId);

      console.log("Sub Category Response", res);

      setSubCategories(res?.data?.data || []);

    } catch (error) {
      console.log(error);

      setSubCategories([]);
    }
  };
  const handleCategoryChange = async (e) => {

    const categoryId = e.target.value;

    setFormData((prev) => ({
      ...prev,
      category_id: categoryId,
      sub_category_id: "",
    }));

    if (categoryId) {
      await loadSubCategories(categoryId);
    } else {
      setSubCategories([]);
    }
  };
  useEffect(() => {
    loadCategories();
  }, []);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };
  const validateForm = () => {
    const newErrors = {};

    if (!formData.color_name.trim()) {
      newErrors.color_name = ["Color Name is required"];
    }

    // if (!formData.color_code.trim()) {
    //   newErrors.color_code = ["Color Code is required"];
    // }

    if (!formData.category_id) {
      newErrors.category_id = ["Category is required"];
    }

    if (!formData.sub_category_id) {
      newErrors.sub_category_id = ["Sub Category is required"];
    }

    setErrors(newErrors);
    return newErrors;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setTimeout(() => {
        const firstErrorField = document.querySelector(".is-invalid");
        if (firstErrorField) {
          firstErrorField.focus();
          firstErrorField.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      }, 100);
      return;
    }
    try {
      const payload = {
        ...formData,
        category_id: Number(formData.category_id),
        sub_category_id: Number(formData.sub_category_id),
        sort_order: Number(formData.sort_order),
        status: Number(formData.status),
      };

      const res = await AddColor(payload);
      if (res?.data?.success) {
        successToast(res?.data.message);
        dispatch(refreshProductList());
        dispatch(closeProductModal());
      }
    } catch (error) {
      console.log(error);
      if (error?.response?.status === 422) {
        setErrors(error.response.data.errors || {});
      } else {
        Swal.fire("Error", "Something went wrong", "error");
      }

    }
  };

  return (
    <form onSubmit={handleSubmit} className="row g-3">

      {/* Color Name */}
      <div className="col-md-6">
        <label>
          Color Name <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          name="color_name"
          value={formData.color_name}
          onChange={handleChange}
          className={`form-control custumform ${errors?.color_name ? "is-invalid" : ""
            }`}
          placeholder="Enter color name"
        />
        {errors?.color_name && (
          <div className="invalid-feedback d-block">
            {errors.color_name[0]}
          </div>
        )}
      </div>

      {/* Color Code */}
      {/* <div className="col-md-6">
        <label>
          Color Code <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          name="color_code"
          value={formData.color_code}
          onChange={handleChange}
          className={`form-control custumform ${errors?.color_code ? "is-invalid" : ""
            }`}
          placeholder="Enter color code"
        />
        {errors?.color_code && (
          <div className="invalid-feedback d-block">
            {errors.color_code[0]}
          </div>
        )}
      </div> */}

      {/* Category */}
      <div className="col-md-6">
        <label>
          Category <span className="text-danger">*</span>
        </label>
        <select
          name="category_id"
          value={formData.category_id}
          onChange={handleCategoryChange}
          className={`form-control custumform ${errors?.category_id ? "is-invalid" : ""
            }`}
        >
          <option value="">Select Category</option>

          {categories.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>

        {errors?.category_id && (
          <div className="invalid-feedback d-block">
            {errors.category_id[0]}
          </div>
        )}
      </div>

      {/* Sub Category */}
      <div className="col-md-6">
        <label>
          Sub Category <span className="text-danger">*</span>
        </label>
        <select
          name="sub_category_id"
          value={formData.sub_category_id}
          onChange={handleChange}
          className={`form-control custumform ${errors?.sub_category_id ? "is-invalid" : ""
            }`}
        >
          <option value="">Select Sub Category</option>

          {subCategories.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </select>

        {errors?.sub_category_id && (
          <div className="invalid-feedback d-block">
            {errors.sub_category_id[0]}
          </div>
        )}
      </div>

      {/* Color Hex */}
      <div className="col-md-6">
        <label>Color Hex</label>

        <div className="d-flex align-items-center gap-2">

          <input
            type="color"
            name="color_hex"
            value={formData.color_hex || "#000000"}
            onChange={handleChange}
            className="form-control form-control-color"
            style={{ width: "70px", height: "45px" }}
          />

          <input
            type="text"
            value={formData.color_hex}
            readOnly
            className="form-control custumform"
            placeholder="#FFFFFF"
          />

        </div>
      </div>

      {/* Sort Order */}
      {/* <div className="col-md-6">
    <label>Sort Order</label>
    <input
      type="number"
      name="sort_order"
      value={formData.sort_order}
      onChange={handleChange}
      className="form-control custumform"
      placeholder="Enter sort order"
    />
  </div> */}

      {/* Status */}
      <div className="col-md-6">
        <label>Status</label>
        <select
          name="status"
          value={formData.status}
          onChange={handleChange}
          className="form-control custumform"
        >
          <option value={1}>Active</option>
          <option value={0}>Inactive</option>
        </select>
      </div>

      {/* Description */}
      <div className="col-md-12">
        <label>Description</label>
        <textarea
          rows="3"
          name="description"
          value={formData.description}
          onChange={handleChange}
          className="form-control custumform"
          placeholder="Enter description"
        />
      </div>

      {/* Submit */}
      <div className="col-12 text-end">
        <button
          type="submit"
          className="add-btn"
          disabled={loading}
        >
          {loading ? "Creating..." : "Create Color"}
        </button>
      </div>

    </form>
  );
}

export default CreateColor;